import { MapMarkerIcon, UsersIcon, RouteIcon } from '@patternfly/react-icons';
import { ComponentType } from 'react';

export interface CampaignTypeConfig {
    label: string;
    icon: ComponentType<{ style?: React.CSSProperties }>;
    color: { bg: string; text: string };
    gradient?: string;
}

const CAMPAIGN_TYPE_CONFIG: Record<string, CampaignTypeConfig> = {
    GeoFenceCampaign: {
        label: 'Geo Fence',
        icon: MapMarkerIcon,
        color: { bg: '#10b981', text: '#ffffff' },
        gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
    },
    ProjectedReachCampaign: {
        label: 'Target Reach',
        icon: UsersIcon,
        color: { bg: '#8b5cf6', text: '#ffffff' },
        gradient: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)'
    },
    TargetReachCampaign: {
        label: 'Target Reach',
        icon: UsersIcon,
        color: { bg: '#8b5cf6', text: '#ffffff' },
        gradient: 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)'
    },
    DrawRoutesCampaign: {
        label: 'Draw Route',
        icon: RouteIcon,
        color: { bg: '#3b82f6', text: '#ffffff' },
        gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
    }
};

const DEFAULT_CONFIG: CampaignTypeConfig = {
    label: '',
    icon: MapMarkerIcon,
    color: { bg: 'rgba(255, 255, 255, 0.2)', text: '#ffffff' },
    gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
};

export function getCampaignTypeConfig(type: string | undefined): CampaignTypeConfig {
    if (!type) {
        return DEFAULT_CONFIG;
    }

    if (CAMPAIGN_TYPE_CONFIG[type]) {
        return CAMPAIGN_TYPE_CONFIG[type];
    }

    // Fallback: use the raw type as label with default styling
    return {
        ...DEFAULT_CONFIG,
        label: type.replace(/Campaign$/i, '').replace(/([A-Z])/g, ' $1').trim()
    };
}
